<template>
  <div class="outside-dashboard">
    <!-- 顶部横幅 -->
    <div class="top-banner">
      <div class="top-title">数据分析系统</div>
    </div>

    <div class="row">
      <!-- 左侧 -->
      <div class="column">
        <dv-border-box-8 class="box">
          <dv-loading v-if="loadingChart" class="white-loading">Loading...</dv-loading>
          <div v-show="!loadingChart" ref="chart1" class="chart"></div>
        </dv-border-box-8>
        <dv-border-box-8 class="box">
          <div class="title">小区排行榜top20</div>
          <dv-loading v-if="loadingTopDevices" class="white-loading">Loading...</dv-loading>
          <dv-scroll-ranking-board v-else :config="ranking1" style="width:100%;height:100%" />
        </dv-border-box-8>
      </div>

      <!-- 中间 -->
      <div class="column center-column">
        <dv-border-box-8 class="number-box-small">
          <dv-loading v-if="loadingTotalData" class="white-loading">Loading...</dv-loading>
          <div class="number-group" v-else>
            <div class="number-item">
              <div class="number-value">{{ totalCount }}</div>
              <div class="number-label">订单总数(条)</div>
            </div>
            <div class="number-item">
              <div class="number-value">{{ totalMoney }}</div>
              <div class="number-label">总返现金额(元)</div>
            </div>
          </div>
        </dv-border-box-8>

        <dv-border-box-8 class="box">
          <div class="title">投递人top20</div>
          <dv-loading v-if="loadingTopUsers" class="white-loading">Loading...</dv-loading>
          <dv-scroll-ranking-board v-else :config="ranking2" style="width:100%;height:100%" />
        </dv-border-box-8>
      </div>

      <!-- 右侧 -->
      <div class="column">
        <dv-border-box-8 class="box">
          <dv-loading v-if="loadingChart" class="white-loading">Loading...</dv-loading>
          <div v-show="!loadingChart" ref="chart2" class="chart"></div>
        </dv-border-box-8>
        <dv-border-box-8 class="box">
          <div class="title">各时间段投递排行榜</div>
          <dv-loading v-if="loadingWeightByTimeRange" class="white-loading">Loading...</dv-loading>
          <dv-scroll-ranking-board v-else :config="ranking3" style="width:100%;height:100%" />
        </dv-border-box-8>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { request } from '@/utils/request'

export default {
  name: 'OutsideDashboard',
  data() {
    return {
      totalCount: 0,
      totalMoney: 0,
      ranking1: { data: [] },
      ranking2: { data: [], rowNum: 8 },
      ranking3: { data: [] },
      chart1: null,
      chart2: null,
      loadingTotalData: false,
      loadingTopUsers: false,
      loadingTopDevices: false,
      loadingWeightByTimeRange: false,
      loadingChart: false
    }
  },
  mounted() {
    // 延迟图表初始化，避免 ref 还没渲染就调用 init
    this.$nextTick(() => {
      this.initCharts()
      this.loadData()
    })
  },
  methods: {
    initCharts() {
      const chart1El = this.$refs.chart1
      const chart2El = this.$refs.chart2

      if (chart1El && chart2El) {
        this.chart1 = echarts.init(chart1El)
        this.chart2 = echarts.init(chart2El)
      }
    },
    loadData() {
      this.getTotalData()
      this.getTopUsers()
      this.getTopDevices()
      this.getWeightByTimeRange()
      this.getLineChartData()
    },
    getTotalData() {
      this.loadingTotalData = true
      Promise.all([
        request({ url: '/order/total_money', method: 'get' }),
        request({ url: '/order/total_count', method: 'get' })
      ])
        .then(([res1, res2]) => {
          this.totalMoney = Number(res1.data.data.total_money)
          this.totalCount = Number(res2.data.data.total)
        })
        .catch(err => console.error('获取总数或金额失败:', err))
        .finally(() => {
          this.loadingTotalData = false
        })
    },
    getTopUsers() {
      this.loadingTopUsers = true
      request({ url: '/order/top_users', method: 'get' })
        .then(res => {
          const raw = res.data.data || []
          this.ranking2 = {
            rowNum: 8,
            data: raw.map(user => ({
              name: user.nickname || '匿名用户',
              value: Number(user.total_weight || 0)
            }))
          }
        })
        .catch(err => console.error('获取投递人top20失败:', err))
        .finally(() => {
          this.loadingTopUsers = false
        })
    },
    getTopDevices() {
      this.loadingTopDevices = true
      request({ url: '/order/device_top20', method: 'get' })
        .then(res => {
          const raw = res.data.data || []
          this.ranking1 = {
            data: raw.map(item => ({
              name: item.device_name || '未知小区',
              value: Number(item.total_weight || 0)
            }))
          }
        })
        .catch(err => console.error('获取小区排行榜失败:', err))
        .finally(() => {
          this.loadingTopDevices = false
        })
    },
    getWeightByTimeRange() {
      this.loadingWeightByTimeRange = true
      request({ url: '/order/weight_by_time_range', method: 'get' })
        .then(res => {
          const raw = res.data.data || []
          this.ranking3 = {
            data: raw.map(item => ({
              name: item.time_range,
              value: Number(item.total_weight || 0),
              text: `${Number(item.total_weight || 0).toFixed(2)}KG`
            }))
          }
        })
        .catch(err => console.error('获取时间段重量失败:', err))
        .finally(() => {
          this.loadingWeightByTimeRange = false
        })
    },
    getLineChartData() {
      this.loadingChart = true
      request({ url: '/order/stat_by_month', method: 'get' })
        .then(res => {
          const raw = res.data.data || []
          const xData = raw.map(item => item.month)
          const countData = raw.map(item => item.count)
          const weightData = raw.map(item => item.total_weight)

          this.setChartOption(this.chart1, '投递重量折线图', xData, weightData, 'KG')
          this.setChartOption(this.chart2, '投递单量折线图', xData, countData, '单')
        })
        .catch(err => console.error('获取折线图数据失败:', err))
        .finally(() => {
          this.loadingChart = false
        })
    },
    setChartOption(chart, title, xData, yData, unit) {
      if (!chart) return
      chart.setOption({
        backgroundColor: 'transparent',
        title: {
          text: title,
          left: 'center',
          textStyle: { color: 'white', fontSize: 16 }
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            const item = params[0]
            return `${item.axisValue}<br/>${item.seriesName}: ${item.data} ${unit}`
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xData,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#fff' }
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#fff' }
        },
        series: [
          {
            name: title,
            type: 'line',
            smooth: true,
            data: yData,
            lineStyle: { color: '#00ffff' },
            itemStyle: { color: '#00ffff' },
            areaStyle: { opacity: 0 }
          }
        ]
      })
    }
  }
}
</script>



<style scoped>
.outside-dashboard {
  width: 100vw;
  height: 100vh;
  background: url('@/assets/outside-bg.jpg') no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  box-sizing: border-box;
}

.top-banner {
  height: 80px;
  background: url('@/assets/outside-top.png') no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top-title {
  font-size: 28px;
  color: white;
  font-weight: bold;
}

.row {
  display: flex;
  flex: 1;
  padding: 10px;
  gap: 10px;
  overflow: hidden;
}

.column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.center-column {
  flex: 1.2;
}

.box {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.chart {
  width: 100%;
  height: 100%;
  min-height: 0;
}

.title {
  color: white;
  font-size: 18px;
  text-align: center;
  margin-bottom: 10px;
}

.number-box-small {
  height: 130px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.number-group {
  display: flex;
  justify-content: space-around;
  width: 100%;
}

.number-item {
  text-align: center;
  color: white;
}

.number-value {
  font-size: 36px;
  font-weight: bold;
}

.number-label {
  margin-top: 10px;
  font-size: 16px;
  color: #3fc0fb;
}

/* ✅ 白色 loading 字体样式 */
.white-loading {
  color: white !important;
  font-size: 16px;
  text-align: center;
}
</style>
